export const TERMS_OF_USE_LINK = 'https://figopetinsurance.com/what-are-figos-terms-use';

export const PRIVACY_PPOLICY_LINK = 'https://figopetinsurance.com/figo-privacy-policy';
